import React from "react"
import { graphql } from "gatsby"
import { Card } from "@mostlycode/ui"
import { Elements } from "prismic-reactjs"
import { valuable } from "utils/worthy"
import styled from "styled-components"
import { getIconFromUrl } from "utils/iconResolver"
import Content from "components/Content"
import StylishIcon from "components/StylishIcon"

const StyledProduct = styled(Card)`
  align-self: center;
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  padding: 0;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0 20px 40px rgba(50, 50, 86, 0.25);
  border-bottom: 5px solid ${(props) => props.theme.colors.kelp};

  h3 {
    margin: 0;
    font-size: 1.8rem;
    text-transform: uppercase;
  }

  p {
    font-size: 1.4rem;
  }

  > .product-content {
    padding: 2rem 7rem 2rem 2rem;
  }

  ${(props) => props.theme.media.tablet_landscape_up`
    & + & {
      margin-top: 0;
    }

    ${
      props.display_style === `horizontal`
        ? `
      width: 50%;
      grid-column: 1 / span ${props.columns};
      margin: 0 auto;
    `
        : ""
    }
  `}
`

const StyledProductIcon = styled(StylishIcon)`
  position: absolute;
  z-index: 10;
  right: 1rem;
  bottom: 2rem;
`

const htmlSerializer = function (type, element, content, children, key) {
  switch (type) {
    case Elements.heading1:
      return <h3 key={key}>{children}</h3>
    default:
      return null
  }
}

function Product({ ...props }) {
  const { description, display_style, product_icon, columns, title } = props
  const icon = getIconFromUrl(product_icon.url)
  return (
    <StyledProduct size="sm" display_style={display_style} columns={columns}>
      <StyledProductIcon icon={icon} bg="blob-two" size={6} />
      <div className="product-content">
        {valuable(title) && (
          <Content content={title} serializer={htmlSerializer} />
        )}
        {valuable(description) && <Content content={description} />}
      </div>
    </StyledProduct>
  )
}

export default Product

Product.defaultProps = {}
Product.propTypes = {}

export const query = graphql`
  fragment ProductFragment on PRISMIC_Product {
    _meta {
      id
      uid
      type
      lang
    }
    title
    description
    body {
      ... on PRISMIC_ProductBodyFeature_list {
        ...FeatureListFragment
      }
    }
    currency
    current_price
    current_price_expiry
    discount_text
    text_before_price
    text_after_price
    regular_price
    product_image
    product_icon
  }
`
